import { render, staticRenderFns } from "./CC212InputPostal.vue?vue&type=template&id=5da54c11&"
import script from "./CC212InputPostal.vue?vue&type=script&lang=js&"
export * from "./CC212InputPostal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports